import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  Grid,
  Button,
  Rating,
} from "@mui/material";

interface ReviewEntry {
  id: string;
  name: string;
  review: string;
  stars: number;
}

const GoogleReviews: React.FC = () => {
  const [reviews, setReviews] = useState<ReviewEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        // const headers = {
        //   Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_API_KEY}`,
        // };
        // const baseId = process.env.REACT_APP_AIRTABLE_BASE_ID;
        const res = await fetch("/data/reviews.json", { cache: "no-store" });
        const json = await res.json();

        const parsed: ReviewEntry[] = json.records.map((r: any) => ({
          id: r.id,
          name: r.fields.name || "Anonymous",
          review: r.fields.review || "",
          stars: Number(r.fields.stars) || 0,
        }));

        setReviews(parsed);
      } catch (err) {
        console.error("Failed to fetch reviews:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  return (
    <Box sx={{ bgcolor: "#1E1E2F", py: 8, userSelect: "none" }}>
      <Container maxWidth="lg">
        <Paper
          elevation={4}
          sx={{
            bgcolor: "#242435",
            p: { xs: 3, md: 5 },
            borderRadius: 2,
          }}
        >
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{
              color: "#e0e0e0",
              fontWeight: 600,
              mb: 4,
            }}
          >
            Customer Reviews
          </Typography>

          <Grid container spacing={3}>
            {loading ? (
              <Typography color="white">Loading reviews...</Typography>
            ) : reviews.length === 0 ? (
              <Typography color="white">No reviews found.</Typography>
            ) : (
              reviews.map((review) => (
                <Grid item xs={12} md={6} key={review.id}>
                  <Box
                    sx={{
                      bgcolor: "#2D2D42",
                      p: 2,
                      borderRadius: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Rating
                      value={review.stars}
                      readOnly
                      precision={1}
                      sx={{ color: "#FFD700" }}
                    />
                    <Typography sx={{ color: "#C0C0C0", mt: 1 }}>
                      "{review.review}"
                    </Typography>
                    <Typography
                      sx={{ color: "#89C7C8", mt: 2, fontSize: "0.9rem" }}
                    >
                      – {review.name}
                    </Typography>
                  </Box>
                </Grid>
              ))
            )}
          </Grid>

          {/* Add Your Google Review Button */}
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="contained"
              color="primary"
              href="https://www.google.com/search?q=Primetime+Sportscards+and+Collectibles"
              target="_blank"
              rel="noopener"
              sx={{
                bgcolor: "#89C7C8",
                color: "#1E1E2F",
                fontWeight: 600,
                "&:hover": {
                  bgcolor: "#76B3B4",
                },
              }}
            >
              Add Your Google Review
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default GoogleReviews;
